export default __webpack_public_path__ + "static/media/news_bottom.4efb49f3.svg";